import type { FaireProductEntity } from "../../entity_types/product";

export const p_9b3g8qbbdn: FaireProductEntity = {
  token: "p_9b3g8qbbdn",
  type: "product",
  name: "Yellow Flowers Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/12eba6420b8b916c10e39c5d7df1beba587806daef3e898446f7f2a62e368fca.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48470264bccb07ebca37dd54d43507ea44873a6372b90f86186a86978f3c1181.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:26.360Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
